// extracted by mini-css-extract-plugin
export default {"page":"Dfa-z","cartModal":"Efa-z","checkout":"Ffa-z","placeholder":"Gfa-z","account":"Hfa-z"};